// action types
import { createRequestTypes } from "../../utils";

export const FETCH_INVOICES = createRequestTypes("FETCH_INVOICES");

// action creators
export const fetchInvoicesRequest = () =>
    ({ type: FETCH_INVOICES.REQUEST });

export const fetchInvoicesSuccess = (invoices) =>
    ({ type: FETCH_INVOICES.SUCCESS, payload: { invoices } });

export const fetchInvoicesFailure = (error) =>
    ({ type: FETCH_INVOICES.FAILURE, payload: { error } });